import { LaunchDarklyContextProps } from '@afterpaytouch/feature'
import { CheckoutAppState } from '../state'
import { LaunchDarklyUserProps } from '@afterpaytouch/feature/lib/types'

export const isValidObject = (object: any): object is object =>
  !!object && (Object.keys(object).length > 0 || Object.keys(Object.getPrototypeOf(object)).length > 0) && object.constructor === Object

export const getUserContext = (state?: CheckoutAppState): LaunchDarklyUserProps => {
  const uuid = state?.consumer?.uuid
  const country = state?.country?.initial ?? undefined
  const email = state?.consumer?.email
  const integration = state?.checkout?.initial?.isIframe ? 'iframe' : state?.checkout?.initial?.isWindowed ? 'popup' : 'redirect'
  const merchantId = state?.checkout?.checkout?.merchant.id
  const source = state?.checkout?.checkout?.merchant.source
  const consumerEmail = state?.checkout?.checkout?.consumer?.email
  const consumerPhone = state?.checkout?.checkout?.consumer?.phoneNumber
  const checkoutMode = state?.checkout?.checkout?.checkoutMode
  const isCrossBorder = state?.checkout?.checkout?.crossRegionUserSignIn !== undefined
  const hasOrderHistory = state?.checkout?.started?.hasOrderHistory
  return {
    kind: 'user',
    name: 'afterpay-checkout',
    uuid,
    country,
    email,
    integration,
    ...(merchantId !== undefined && { merchantId }),
    ...(source !== undefined && { source }),
    ...(consumerEmail !== undefined && { consumerEmail }),
    ...(consumerPhone !== undefined && { consumerPhone }),
    ...(checkoutMode !== undefined && { checkoutMode }),
    ...(hasOrderHistory !== undefined && { hasOrderHistory }),
    isCrossBorder,
  }
}

export const getLDContext = (state: CheckoutAppState, onLoad: () => void, onDone: () => void): LaunchDarklyContextProps => {
  const userContext = getUserContext(state)

  return {
    userProps: userContext,
    onLoad,
    onDone,
  }
}
